define('Components/ReorderWidget/js/models/ReorderWidgetInstanceModel',['jquery',
        'app',
        'WidgetInstanceModel',
        'UrlFactory'
    ],
    function ($, app, WidgetInstanceModel, UrlFactory) {
        return WidgetInstanceModel.extend({
            name:'ReorderWidgetModel',
            getReorders: function() {
                var customer = app.getCustomer(),
                    orders = customer.getOrders(),
                    reorders = orders.filterReorder();
                return reorders;
            },
            getReorderOrders: function() {
                var reorders = this.getReorders(),
                    selectedOrders = 0,
                    orders =  [];

                if (reorders.length <= 0) {
                    return _([])
                }
                var i = 0;
                while (selectedOrders < 3 && i < reorders.length) {
                    var order = reorders[i]
                    if (order && order.get('reorder_available')) {
                        orders.push(order)
                        selectedOrders++
                    }
                    i++;
                }
                return _(orders)
            }
        })
    });
